export const environment = {
  production: true,
  resourcesUrl: 'https://img.pastoukhov.com'
};
